/* eslint-disable max-len */
import { TcV2CheckoutTermsListComponent } from './components/checkout-terms-list/checkout-terms-list.component';
import { TcV2LoyaltyProgramsListItemDesktopComponent } from './components/loyalty-programs-list-item-desktop/loyalty-programs-list-item-desktop.component';
import { TcV2LoyaltyProgramsListItemMobileComponent } from './components/loyalty-programs-list-item-mobile/loyalty-programs-list-item-mobile.component';
import { TcV2ProgramsBannerComponent } from './components/programs-banner/programs-banner.component';
/* eslint-enable max-len */

export let tcV2ComponentMap = {
  'tcv2-loyalty-programs-list-item-desktop':
    TcV2LoyaltyProgramsListItemDesktopComponent,
  'tcv2-loyalty-programs-list-item-mobile':
    TcV2LoyaltyProgramsListItemMobileComponent,
  'tcv2-checkout-terms-list': TcV2CheckoutTermsListComponent,
  'tcv2-programs-banner': TcV2ProgramsBannerComponent,
};

export const changeTcV2ComponentMap = (newMap: {
  [key: string]: any;
}): void => {
  tcV2ComponentMap = {
    ...tcV2ComponentMap,
    ...newMap,
  };
};
